<template>
    <div class="state-select-spinner">
        <div class="spinner-container" ref="spinnerContainer" @click.stop>
            <div class="result-box" :class="{active: showPop, error: required}" @click="togglePop">
                <input class="result-input"
                    type="text"
                    :value="selectedStateText"
                    :placeholder="placeholder"
                    @change="handleAutoFill"
                    autocomplete="address-level1">
                <span v-show="selectedStateText !== ''" class="top-placeholder">{{ $t( 'cart.address.state' ) }}</span>
                <span class="arrow-icon icon-icon_arrow-down"></span>
                <span class="required-icon">*</span>
            </div>
            <div class="drop-down-box" v-show="showPop">
                <div class="input-box">
                    <input type="text" v-model="searchText">
                    <span class="icon-icon_search-2"></span>
                </div>
                <ul class="state-list">
                    <li class="no-match" v-show="filteredStateList.length===0">
                        {{$t('countrySelectSpinner.notAvailable1')}}
                    </li>
                    <li class="state-item"
                        :class="{ active: item.name === selectedState }"
                        v-for="(item, index) in filteredStateList"
                        :key="index"
                        @click="$emit('stateSelect',item.name); showPop = false;">
                        {{item.name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue, { PropType } from 'vue';
export default Vue.extend({
    name: 'stateSelectSpinner',
    props: {
        list: Array as PropType<any[]>,
        selected: String,
        error: Boolean,
        selectedState: String,
    },
    created() {

        this.checkAndRenderStateText();

    },
    data () {

        return {

            searchText: '' as string,
            showPop: false,
            placeholder: this.$tc( 'cart.address.state' ),
            selectedStateText: '',
            required: false

        };

    },
    computed: {
        supportedStateList(): any[] {

            return this.list;

        },
        filteredStateList (): any[] {

            if ( !this.searchText ) {

                return this.supportedStateList.slice();

            }

            const text = this.searchText.toLowerCase();

            return this.supportedStateList.filter( item => item.name.toLowerCase().includes( text ));

        }

    },
    watch: {

        list () {

            this.checkAndRenderStateText();

        },

        showPop ( n ) {

            if ( n ) {

                document.addEventListener( 'click', this.clickListener );

            } else {

                this.searchText = '';
                document.removeEventListener( 'click', this.clickListener );

            }

        },

        selectedState () {

            this.checkAndRenderStateText();

        },

        error () {

            this.required = this.error;

        }

    },
    methods: {

        clickListener () {

            this.showPop = false;

        },

        /**
         * 检查state是否合法，合法则渲染state文字
         */
        checkAndRenderStateText () {

            let target = this.supportedStateList.filter( item => item.key === this.selectedState || item.name === this.selectedState )[0];
            if ( target ) {

                this.selectedStateText = target.name;

            } else if ( this.list.length !== 0 ) {

                this.selectedStateText = '';
                this.$emit( 'stateSelect', '' );

            }

        },
        togglePop () {

            this.showPop = !this.showPop;
            this.$emit( 'cancelErr' );

        },
        handleAutoFill( e: Event ) {

            if ( this.list.length === 0 ) {

                return;

            }
            const input = ( e.target as HTMLInputElement );
            const target = this.supportedStateList.filter( item => item.key === input.value || item.name === input.value )[0];
            if ( target ) {

                this.$emit( 'stateSelect', target.name );

            } else {

                input.value = this.selectedStateText;

            }

        }

    }

});
</script>
<style lang='less' scoped>
.state-select-spinner {
    margin-bottom: 20px;
    font-size: 16px;
    text-align: left;
    position: relative;
    display: inline-block;
    width: calc((100% - 20px) / 2);
    z-index: 1;
    @media @snapeak_mobile {
        margin-bottom: 0.3rem;
        font-size: 0.28rem;
        width: 100%;
    }
    input {
        outline-offset: 0;
        border: none;
        font-size: 16px;
        font-weight: 500;
        padding: 0;
        box-sizing: border-box;
        @media @snapeak_mobile {
            font-size: 0.28rem;
        }
    }
    .input-clue {
        margin-bottom: 20px;
        @media @snapeak_mobile {
            margin-bottom: 0.3rem;
        }
    }
    .spinner-container {
        position: relative;
        z-index: 3;
        .result-box {
            display: block;
            align-items: center;
            border: 1px solid transparent;
            box-shadow: 0 0 6px 2px rgba(0,0,0,.14);
            padding-left: 20px;
            padding-right: 20px;
            border-radius: 8px;
            position: relative;
            box-sizing: border-box;
            cursor: pointer;
            @media @snapeak_mobile {
                padding-left: 0.4rem;
                padding-right: 0.32rem;
            }
            .top-placeholder {
                position: absolute;
                left: 20px;
                top: 0;
                font-size: 14px;
                background-color: @bg_02;
                transform: translateY(-50%);
                font-weight: 500;
                padding: 0 4px;
                color: @b_6;
                @media @snapeak_mobile {
                    font-size: .24rem;
                    background-color: @bg_01;
                }
            }
            .result-input {
                pointer-events: none;
                height: 48px;
                user-select: none;
                width:90%;
                background-color: transparent;
                &::placeholder{
                    color: @font_secondary;
                }
                @media @snapeak_mobile {
                    height: 0.78rem;
                }
            }
            &.active {
                border-color: @brand_light;
                box-shadow: none;
            }
            &.error {
                border-color: #e74330;
            }
            .arrow-icon {
                font-size: 16px;
                color: @brand_light;
                position: absolute;
                top: 50%;
                pointer-events: none;
                transform: translateY(-50%);
                right: 30px;
                font-weight: 500;
                @media @snapeak_mobile {
                    font-size: 0.26rem;
                    right: 0.32rem;
                }
            }
            .required-icon {
                position: absolute;
                color: #e74330;
                right: -10px;
                font-size: 18px;
                top: 0;
                @media @snapeak_mobile {
                    font-size: 0.32rem;
                    right: -0.15rem;
                }
                @media screen and (max-width: 500px) {
                    right: -0.2rem;
                }
            }
        }
        .drop-down-box {
            background-color: @bg_02;
            border: 1px solid @brand_light;
            border-top: none;
            width: calc(100% - .1rem);
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 100%);
            .input-box {
                width: 100%;
                box-sizing: border-box;
                padding: 0 10px;
                margin-top: 10px;
                position: relative;
                @media @snapeak_mobile {
                    padding: 0 0.04rem;
                }
                input {
                    padding: 0 20px;
                    width: 100%;
                    height: 36px;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
                    background-color: @bg_03;
                    @media @snapeak_mobile {
                        padding: 0 0.36rem;
                        height: 0.76rem;
                    }
                }
                .icon-icon_search-2 {
                    color: #777;
                    font-size: 16px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 24px;
                    pointer-events: none;
                    @media @snapeak_mobile {
                        font-size: 0.28rem;
                        right: 0.24rem;
                    }
                }
            }
            .state-list {
                max-height: 180px;
                width: 100%;
                padding: 0 24px 26px;
                text-align: left;
                box-sizing: border-box;
                overflow-y: auto;
                font-size: 0;
                @media @snapeak_mobile {
                    max-height: 3.08rem;
                    padding: 0.26rem 0.36rem;
                }
                .no-match {
                    margin-top: 26px;
                    margin-right: 30px;
                    display: inline-block;
                    font-size: 16px;
                    .notify-btn {
                        color: @brand_light;
                        cursor: pointer;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                    @media @snapeak_mobile {
                        margin-top: 0;
                        display: block;
                        margin-right: 0;
                        font-size: 0.24rem;
                    }
                }
                .state-item {
                    cursor: pointer;
                    margin-top: 26px;
                    width: 290px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: inline-block;
                    font-size: 16px;
                    @media @snapeak_mobile {
                        display: block;
                        margin-top: 0.5rem;
                        margin-right: 0;
                        width: auto;
                        &:nth-of-type(2) {
                            margin-top: 0;
                        }
                    }
                    &.active,
                    &:hover {
                        color: @b_6;
                    }
                }
            }
        }
    }
    .spinner-clue {
        margin-top: 20px;
        font-size: 14px;
        color: #e74330;
        line-height: 1.2;
        @media @snapeak_mobile {
            margin-top: 0.2rem;
            font-size: 0.24rem;
        }
    }
}
</style>
